var map = {
	"./bank-transfer.svg": 825,
	"./betnearn-ico.svg": 826,
	"./birthday-bonus-ico.svg": 827,
	"./birthday.svg": 828,
	"./bonus-code-ico.svg": 829,
	"./bonus-ico.svg": 830,
	"./bonus-received-ico.svg": 831,
	"./bonus.svg": 832,
	"./business-account-upgrade-ico.svg": 833,
	"./check-in-daily-ico.svg": 834,
	"./checked.svg": 835,
	"./cloud-pointer.svg": 836,
	"./coin.svg": 837,
	"./crypto.svg": 838,
	"./daily-bonus-ico.svg": 839,
	"./daily-limit.svg": 840,
	"./deposit-delay-bonus-ico.svg": 841,
	"./e-wallet.svg": 842,
	"./earn-x33-coin-ico.svg": 843,
	"./email.svg": 844,
	"./facebook.svg": 845,
	"./feedback.svg": 846,
	"./first-bet-ico.svg": 847,
	"./games-rebate-ico.svg": 848,
	"./info.svg": 849,
	"./instagram.svg": 850,
	"./instant-rebate.svg": 851,
	"./live-casino-rebate-ico.svg": 852,
	"./lucky-spin-ico.svg": 853,
	"./messenger.svg": 854,
	"./mobile-app-deposit-ico.svg": 855,
	"./monthly-cash.svg": 856,
	"./msg-activity.svg": 857,
	"./msg-ann.svg": 858,
	"./msg-notice.svg": 859,
	"./new-icon.svg": 860,
	"./people-ico.svg": 861,
	"./quick-pay.svg": 862,
	"./rescue-bonus-ico.svg": 863,
	"./rescue-lc-ico.svg": 864,
	"./rescue-slots-ico.svg": 865,
	"./return.svg": 866,
	"./sc-bc-active-ico.svg": 867,
	"./sc-bc-ico.svg": 868,
	"./sc-bi-active-ico.svg": 869,
	"./sc-bi-ico.svg": 870,
	"./sc-mail-active-ico.svg": 871,
	"./sc-mail-ico.svg": 872,
	"./sc-mp-active-ico.svg": 873,
	"./sc-mp-ico.svg": 874,
	"./sc-pin-active-ico.svg": 875,
	"./sc-pin-ico.svg": 876,
	"./slots-rebate-ico.svg": 877,
	"./sms.svg": 878,
	"./sports-rebate-ico.svg": 879,
	"./telegram.svg": 880,
	"./twitter.svg": 881,
	"./vip-up-level-ico.svg": 882,
	"./vip-weekly-bonus.svg": 883,
	"./wallet-balance-interest-ico.svg": 884,
	"./wallet-ico.svg": 885,
	"./weekly-tournament-ico.svg": 886,
	"./welcome-bonus-188-ico.svg": 887,
	"./welcome-bonus-ico.svg": 888,
	"./whatsapp-original.svg": 889,
	"./whatsapp.svg": 890,
	"./withdrawal-delay-bonus-ico.svg": 891,
	"./withdrawal.svg": 892,
	"./x33-coin.svg": 893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;